import React from 'react';

export function SocialLink({ href, label, Icon }) {
  return (
    <a 
      href={href} 
      className="flex items-center gap-3 py-3 text-sm text-[black]/90 hover:text-[#10b981] transition-colors group"
    >
      <Icon className="w-4 h-4 text-[#10b981] transition-transform group-hover:scale-110" />
      <span>{label}</span>
    </a>
  );
}